import NotFoundBlock from "@/components/base/NotFoundBlock";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta(
    "页面不存在 - 红桃网",
    "你访问的页面不存在或已下线，请返回红桃网首页继续浏览娱乐资讯、影视推荐与综艺动态。",
    "红桃网,页面不存在",
  );

  return (
    <NotFoundBlock
      title="页面走丢了"
      description="这个地址可能写错了，或者页面已经下线。你可以回到首页，或者去娱乐资讯频道看看今天有什么新内容。"
      backTo="/news"
      backLabel="去看看资讯"
    />
  );
}